export const DEFAULT_DELAY_IN_MILLISECONDS = 10000;
export const DELAY_DISABLED_VALUE = 0;
